import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconListAdd: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconListAdd"><Path d="M3.75 6H20.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/><Path d="M3.75 12H10.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/><Path d="M3.75 18H10.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/><Path d="M14.75 14.75L21.25 14.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/><Path d="M18 11.75V18.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/></CentralIconBase>;
});

export default IconListAdd;
